module.exports = "/_next/static/images/to-0da693dc8ce956a70665b0a17b4763ff.svg";